import React, {PureComponent} from "react"
import GenericModal from "@irati/ui/src/GenericModal"
import RewardsModalContent from "./RewardsModalContent"

interface State {
  show: boolean
}

export default class RewardsModal extends PureComponent<{}, State> {
  state: State = {show: false}

  show = () => {
    this.setState({show: true})
  }
  closeModal = () => this.setState({show: false})

  render() {
    return (
      <GenericModal show={this.state.show} onHide={this.closeModal} customWidth={600} hideActions>
        <RewardsModalContent closeModal={this.closeModal} />
      </GenericModal>
    )
  }
}
